const Raptor = Mach.requireModule('Raptor');
const SLRaptor = Mach.requireModule('SLRaptor');
const Horn = Mach.requireModule('SLCHorn');
const SLCompass = Mach.requireModule('SLCompass');

const { region, cityId } = SLCompass?.getCompassInfo() || {};
const safeEnv = Mach?.env || {};
const defaultTags = {
  osName: safeEnv.osName ?? '',
  osVersion: safeEnv.osVersion ?? '',
  appVersion: safeEnv.version ?? '',
  platform: safeEnv.isAndroid ? 'Android' : 'iOS',
  env: safeEnv.isDebug ? 'Test' : 'Prod',
  slEnv: safeEnv.isDebug ? 'Test' : 'Prod',
  slAppVer: safeEnv.version ?? '',
  slPlatform: safeEnv.isAndroid ? 'Android' : 'iOS',
  bundleVersion: safeEnv.bundleVersion ?? '',
  bundleName: safeEnv.bundleName ?? '',
  bid: safeEnv.schemeParams?.bid || '',
  cid: safeEnv.schemeParams?.cid || '',
  specialScene: safeEnv.schemeParams?.specialScene || '',
  supplyId: safeEnv.schemeParams?.supplyId || '',
  region,
  cityId,
};

export type IRaptorReportResult = 1 | 0
export interface IBizCardParams {
  /** 店铺名称缺失 */
  shopNameMissing?: IRaptorReportResult;
  /** 店铺图片缺失 */
  shopMainPicMissing?: IRaptorReportResult;
  /** 店铺跳链缺失 */
  shopJumpUrlMissing?: IRaptorReportResult;

  /** 菜品名称缺失 */
  dishNameMissing?: IRaptorReportResult;
  /** 菜品图片缺失 */
  dishMainPicMissing?: IRaptorReportResult;
  /** 菜品售价缺失 */
  dishPriceMissing?: IRaptorReportResult;
  /** 菜品跳链缺失 */
  dishJumpUrlMissing?: IRaptorReportResult;

  /** 卡片标题缺失 */
  cardTitleMissing?: IRaptorReportResult;
  /** 卡片跳链缺失 */
  cardJumpUrlMissing?: IRaptorReportResult;
  /** 卡片元素名称缺失 */
  cardElemNameMissing?: IRaptorReportResult;
  /** 卡片元素图片缺失 */
  cardElemMainPicMissing?: IRaptorReportResult;
  /** 卡片元素跳链缺失 */
  cardElemJumpUrlMissing?: IRaptorReportResult;
}

export interface IBizCardReporterParams {
  params: IBizCardParams;
  tags?: any;
  sampleRate?: number;
}

/**
 * 检查Value类型是否为字符串并转换
 * @param obj
 * @returns
 */
const checkAndConvertToString = (obj) => {
  if (Array.isArray(obj) || typeof obj !== 'object') {
    return obj;
  }
  const convertObj = {};
  Object.entries(obj).forEach(([key, value]) => {
    if (typeof value === 'string') {
      convertObj[key] = value;
    } else if (typeof value === 'number') {
      convertObj[key] = String(value);
    }
  });

  return convertObj;
};

/**
 * 找寻 puzzle 元素矩阵的某个具体元素
 */
export function findTargetFromMatrix(matrix: {type: string; data: any;}[][], key: string): any {
  if (!Array.isArray(matrix) || matrix?.length === 0 || !Array.isArray(matrix?.[0])) {
    return {};
  }
  let target = null;
  matrix.forEach((row: any[]) => row.forEach((item) => {
    if (item?.type === key) {
      target = item.data;
    }
  }));

  if (!target) {
    return {};
  }

  return target;
}

/**
 * 判断数值有异常时才上报
 */
function hasErrorCheck(params) {
  let hasError = false;
  Object.values(params).forEach((value) => {
    if (value === 1) {
      hasError = true;
    }
  });
  return hasError;
}

/**
 * 移除状态为正常的上报参数
 */
function paramsParser(params) {
  const result = {};
  Object.entries(params).forEach(([key, value]) => {
    if (value === 1) {
      result[key] = value;
    }
  });
  return result;
}

function checkIfHornAllow(): boolean {
  const config = Horn?.getAppConfig?.();
  const { bizCardReporterSwitch } = config || {};
  return bizCardReporterSwitch ?? false;
}

export function reportBizCardMetrics({ params, tags, sampleRate }: IBizCardReporterParams) {
  if (!params || !hasErrorCheck(params) || !checkIfHornAllow()) {
    return;
  }
  const safeInputTag = typeof tags === 'object' ? tags : {};
  const uploadTags = { ...defaultTags, ...safeInputTag };
  const uploader = SLRaptor || Raptor;
  uploader?.reportMetrics?.(paramsParser(params), checkAndConvertToString(uploadTags), (sampleRate || 1.0));
}
